import Image from 'next/image'
import { getCMSImageUrl } from '@/utils/image-utils/get-cms-image'
import { Directus_Files, Post_Files } from '@/ts/graphqlschema'

type TGalleryGridImageProps = {
  gallery: null | Array<{ directus_files_id: Directus_Files }> | Post_Files[]
}

export default function GalleryGridImage(props: TGalleryGridImageProps) {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-2">
        {props.gallery &&
          props.gallery.map((item, index) => {
            const thumbnailUrl = getCMSImageUrl(item.directus_files_id, 'lg')
            const title = item?.directus_files_id?.title || 'Mr Biker Saigon'
            const imageClass =
              index === 0 || index === 3
                ? 'col-span-2'
                : 'col-span-2 md:col-span-1'
            return (
              <div key={index} className={`w-full ${imageClass}`}>
                <div className="z-10 w-full h-full">
                  <Image
                    layout="responsive"
                    objectFit="cover"
                    width={700}
                    height={475}
                    src={thumbnailUrl}
                    alt={item?.directus_files_id?.title}
                  />
                  <h6 className="mt-1 mb-2 font-sans text-base italic dark:text-gray-2 text-gray-7">
                    {title}
                  </h6>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}
